<template src="./restrictionsDetail.template.html"></template>
<script>  
import moment from "moment-timezone";
    export default {
        name: "restrictionsDetail",
        // props: ["restrictionsDetailObj"],
        props: [],
        data() {
            return {
                restrictionsDetail: null,
                restrictionId: -1,
                propertyList: [],
                unitList: [],
                filterObj: {
                    SortBy: null,
                    SortOrder: null
                },
            };
        },
        methods: {
            getRestrictionDetail: function () {
                let scope = this;
                scope.restrictionId = scope.$route.params.restrictionId;

                scope.$store.dispatch("dataRequestHandler", {
                    key: "GetRestrictionDetail",
                    params: {
                        RestrictionId: scope.restrictionId
                    },
                    callback: function (err, response) {
                        if (response) {
                            console.log(response);
                            // .utc()
                            scope.restrictionsDetail = response.restrictionsDetail;
                            // scope.propertyList = response.propertyList;
                            for(var i =0 ;scope.restrictionsDetail.EffectiveDates.length > i; i++){
                                scope.restrictionsDetail.EffectiveDates[i].EffectiveEndDate = moment.utc(scope.restrictionsDetail.EffectiveDates[i].EffectiveEndDate).format("DD MMM YYYY");
                                scope.restrictionsDetail.EffectiveDates[i].EffectiveStartDate = moment.utc(scope.restrictionsDetail.EffectiveDates[i].EffectiveStartDate).format("DD MMM YYYY");
                            }
                        } else {
                            console.log(err);
                        }
                    }
                });
            },
            getPropertyMetaData: function () {

                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetPropertiesBySearchText",
                    params: {},
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);

                        }
                    }
                });

            },

            saveRestrictionDetails() {
                let scope = this;
                if ((scope.restrictionsDetail.PropertyId === null || scope.restrictionsDetail.PropertyId === undefined) || (scope.restrictionsDetail.UnitId === null || scope.restrictionsDetail.UnitId === undefined) || (scope.restrictionsDetail.RestrictionName === null || scope.restrictionsDetail.RestrictionName === undefined) || scope.restrictionsDetail.Description === null || scope.restrictionsDetail.Description === undefined) {
                    scope.$store.dispatch("toastr", {
                        type: "warning",
                        header: "Warning",
                        message: "Property Name,  Unit Name, RestrictionName,Description are mandatary"
                    });
                    return;
                }
                else if ((scope.restrictionsDetail.EffectiveDates.length == 0) || (scope.restrictionsDetail.EffectiveDates.length > 0 && (scope.restrictionsDetail.EffectiveDates[0].EffectiveEndDate == null || scope.restrictionsDetail.EffectiveDates[0].EffectiveStartDate == null))) {
                    scope.$store.dispatch("toastr", {
                        type: "warning",
                        header: "Warning",
                        message: "Dates are mandatory"
                    });
                    return;
                }


                scope.$store.dispatch("dataRequestHandler", {
                    key: "SaveRestrictionDetail",
                    params: scope.restrictionsDetail,
                    callback: function (err, response) {
                        if (response) {
                            console.log(response);
                            scope.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Restriction successfully saved"
                            });
                            scope.$router.push("/restrictionList");

                        } else {
                            console.log(err);
                        }
                    }
                });

            },
            updateStartDate(key, dateObj, thisObj) {
                thisObj.EffectiveStartDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
            },
            updateEndDate(key, dateObj, thisObj) {
                thisObj.EffectiveEndDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
            },
            addEffectiveDate() {
                this.restrictionsDetail.EffectiveDates.push(JSON.parse(JSON.stringify({ EffectiveStartDate: null, EffectiveEndDate: null })));
            },
            getPropertyUnits() {
                let scope = this;
                this.$store.dispatch("dataRequestHandler", {
                    key: "GetUnitList",
                    params: {
                        PropertyId: scope.restrictionsDetail.PropertyId,
                        StatusId: 1,
                        filterObj: scope.filterObj
                    },
                    callback: function (err, response) {
                        if (response) {
                            scope.unitList.splice(0, scope.unitList.length, ...response.recordsets[1]);
                        } else {
                            console.log(err);
                        }
                    }
                });
            },
            cancelRestrictionDetails() {
                this.$router.push("/restrictionList");
            },
            updateRestrictionType(val){
                this.restrictionsDetail.RestrictionTypeId=val
            }
        },
        computed: {},
        watch: {
            $route: "getRestrictionsDetail",
            'restrictionsDetail.PropertyId': function (newVal) {
                console.log(newVal);
                if (newVal)
                    this.getPropertyUnits();
            },
            // restrictionsDetailObj: {
            //     handler: function (resObj, oldVal) {
            //         if (resObj) {
            //             this.restrictionId = resObj.restrictionId
            //             this.getRestrictionDetail();
            //         }
            //     },
            //     deep: true

            // }
        },
        mounted() {
            this.getRestrictionDetail();
            this.getPropertyMetaData();
        }
    }
</script>